export const AuthToken = {
    accessToken: localStorage.getItem('accessToken'),
}
